/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto_Wealthlane_AwardSettlementService_Application_Contracts } from '../models/Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto_Wealthlane_AwardSettlementService_Application_Contracts';
import type { Wealthlane_AwardSettlementService_Dtos_Common_FileExportTemplate } from '../models/Wealthlane_AwardSettlementService_Dtos_Common_FileExportTemplate';
import type { Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto } from '../models/Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto';
import type { Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ExportCashTransferRequestDto } from '../models/Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ExportCashTransferRequestDto';
import type { Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantCashTransferServiceService {
  /**
   * @param requestBody
   * @returns Wealthlane_AwardSettlementService_Dtos_Common_FileExportTemplate OK
   * @throws ApiError
   */
  public static postApiAwardSettlementApiAppParticipantCashTransferServiceExportCashTransferRequest(
    requestBody?: Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ExportCashTransferRequestDto
  ): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Common_FileExportTemplate> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award-settlement/api/app/participant-cash-transfer-service/export-cash-transfer-request',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param cashTransferStatusIds
   * @param transferTypeIds
   * @param cancelStatusIds
   * @param requestDate
   * @param companyIds
   * @returns Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto OK
   * @throws ApiError
   */
  public static getApiAwardSettlementApiAppParticipantCashTransferServiceCashTransferDashboard(
    cashTransferStatusIds?: Array<number>,
    transferTypeIds?: Array<number>,
    cancelStatusIds?: Array<number>,
    requestDate?: string,
    companyIds?: Array<string>
  ): CancelablePromise<
    Array<Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer-dashboard',
      query: {
        CashTransferStatusIds: cashTransferStatusIds,
        TransferTypeIds: transferTypeIds,
        CancelStatusIds: cancelStatusIds,
        RequestDate: requestDate,
        CompanyIds: companyIds,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param cashTransferStatusIds
   * @param transferTypeIds
   * @param cancelStatusIds
   * @param requestDate
   * @param companyIds
   * @param sorting
   * @param skipCount
   * @param maxResultCount
   * @returns Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto_Wealthlane_AwardSettlementService_Application_Contracts OK
   * @throws ApiError
   */
  public static getApiAwardSettlementApiAppParticipantCashTransferServiceCashTransfer(
    cashTransferStatusIds?: Array<number>,
    transferTypeIds?: Array<number>,
    cancelStatusIds?: Array<number>,
    requestDate?: string,
    companyIds?: Array<string>,
    sorting?: string,
    skipCount?: number,
    maxResultCount?: number
  ): CancelablePromise<Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto_Wealthlane_AwardSettlementService_Application_Contracts> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer',
      query: {
        CashTransferStatusIds: cashTransferStatusIds,
        TransferTypeIds: transferTypeIds,
        CancelStatusIds: cancelStatusIds,
        RequestDate: requestDate,
        CompanyIds: companyIds,
        Sorting: sorting,
        SkipCount: skipCount,
        MaxResultCount: maxResultCount,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto OK
   * @throws ApiError
   */
  public static putApiAwardSettlementApiAppParticipantCashTransferServiceCashTransfer(
    requestBody?: Array<Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto>
  ): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
